<template>
      <a-button :size="size" v-if="!formRecord.id" :style="style" type="primary" @click="handleOpen">
        + 标签
      </a-button>
      <a-button :size="size" v-else :style="style"  @click="handleOpen">
        编辑
      </a-button>
      <a-modal
        :title="formRecord.id ? '编辑标签':'创建标签'"
        v-model:visible="openDia" 
        @cancel="resetForm" 
        @ok="handleConfirm" 
        :confirm-loading="loading"
      >
        <a-form :model="formRecord" >
          <a-form-item label="名称" name="name">
            <a-input  v-model:value="formRecord.name" />
          </a-form-item>

          <a-form-item   label="分类"  name="category">
            <a-select
              :disabled="!!formRecord.id"
              :allowClear="true"
              style="width: 100px;"
              v-model:value="formRecord.category"
              :options="labelCategoryOptions"
            />
          </a-form-item>
          
        </a-form>
      </a-modal>

   
  </template>
  <script>
  
  import { defineComponent, reactive, ref } from 'vue'
  import request from '@/utils/request'
  import { Modal, message } from 'ant-design-vue';

  const FormRecord = {
    id: '',
    name: '',
    category: '打标',
  }

  export default defineComponent({
    emits: ['ok'],
    props: ['record', 'style', 'size'],
    // components:{CheckCircleOutlined,CloseCircleOutlined},
    data(){
      return {
        remoteExecutorsShowup: "0",
        loading: false,
        openDia: false,
        labelCategoryOptions: [
          {
            label: "打标", value: '打标'
          }, {
            label: "评估", value: '评估'
          },
        ],
        formRecord: {
          ...FormRecord,
        },
        // imageUrl: '',
      }
    },
    mounted() {
      if (this.record.id) {
        this.formRecord = {
          ...FormRecord,
          ...this.record,
        }
      }
      // this.imageUrl = this.modelValue
    },
    methods: {
      resetForm() {
        this.formRecord = {
          ...FormRecord,
          ...this.record,
        }
      },
      handleSelectExecutor(executor){
        // target_host: http://222.186.161.109/api/
        this.formRecord.remote_url = executor.remote_url
        if (executor.selected) {
          this.formRecord.remote_url = ''
          executor.selected = false
        } else {

          executor.selected = true
          for (let k in this.executors) {
            if (this.executors[k].executor_id != executor.executor_id) {
              this.executors[k].selected = false
            }
          }
          this.remoteExecutorsShowup = "0"
        }
      },
      
      async handleConfirm(){
        this.loading = true
        var req = null
        if (!this.formRecord.id) {
            req = request.post(`/api/testcase/labels/`, {
            ...this.formRecord,
          }, null)
        } else {
           req = request.put(`/api/testcase/labels/${this.formRecord.id}`, {
            ...this.formRecord,
          }, null)
        }
        req.then((rsp) => {
            if (rsp.code == 0) {
              message.success('操作成功')
            } else {
              message.error(rsp.msg)
            }
          }).catch((err) => {
            message.error(err.message)
          }).finally(() => {
            this.loading = false
            this.openDia = false
            this.resetForm()
            this.$emit('ok')
          })
       
      },
      handleOpen: function() {
        this.openDia = true
        this.formRecord = {
          ...FormRecord,
          ...this.record,
        }
      }
    },
  })
  </script>
  <style lang='scss' scoped>
  
  </style>